import { Injectable } from '@angular/core';
import { LocalDbService } from '../local-db-service';
import { Stock } from '../../entities/stock';

@Injectable({ providedIn: 'root' })
export class StockRepository {
  private get table() {
    return this.db.stockTable;
  }

  constructor(private readonly db: LocalDbService) {}

  async getAll(): Promise<Stock[]> {
    const rows = await this.table.toArray();
    return rows.map(row => new Stock(row));
  }

  async getById(warehouseId: number, productId: number): Promise<Stock | undefined> {
    const row = await this.table.get([warehouseId, productId]);
    return row ? new Stock(row) : undefined;
  }

  async getByWarehouseId(warehouseId: number): Promise<Stock[]> {
    const rows = await this.table.where('warehouseId').equals(warehouseId).toArray();
    return rows.map(row => new Stock(row));
  }

  async getByProductId(productId: number): Promise<Stock[]> {
    const rows = await this.table.where('productId').equals(productId).toArray();
    return rows.map(row => new Stock(row));
  }

  upsert(stock: Stock): Promise<[number, number]> {
    return this.table.put(stock);
  }

  upsertBulk(stocks: Stock[]): Promise<[number, number]> {
    return this.table.bulkPut(stocks);
  }

  delete(warehouseId: number, productId: number): Promise<void> {
    return this.table.delete([warehouseId, productId]);
  }

  clear(): Promise<void> {
    return this.table.clear();
  }
}
